import React from 'react';
import styles from './index.module.scss';

const UnknownImg = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
  path_to_folder,
}) => {

  // Обработка imgName - оставляем только часть после последнего '\'
  const processedImgName =
    imgName && imgName.includes('\\') ? imgName.substring(imgName.lastIndexOf('\\') + 1) : imgName;

  return (
    <div className={styles.unknownImg}>
      <h2 className={styles.title}>Неизвестное Изображение</h2>
      <p className={styles.description}>Компонент для неизвестного изображения</p>
      {imgName && imgName !== 'none' && (
        <div className={styles.imageContainer}>
          <h4>Изображение:</h4>
          <p className={styles.imagePath}>Путь: {path_to_folder + processedImgName}</p>
          <img src={path_to_folder + processedImgName} alt='Изображение' className={styles.image} />
        </div>
      )}
      {imgName && imgName === 'none' && (
        <div className={styles.additionalData}>
          <h4>Имя изображения:</h4>
          <p>{imgName}</p>
        </div>
      )}
    </div>
  );
};

export default UnknownImg;
